import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from './axiosInstance';
export const Header = () => {
    const [sroller, setScroller] = useState([]);

    return (
        <>
            {/* Mobile Online Admission Bar */}
           <header className="top-header">
      <nav className="navbar navbar-expand align-items-center justify-content-between gap-3">
        <div className="btn-toggle">
          <a
        href="#offcanvasPrimaryMenu"
        data-bs-toggle="offcanvas"
        role="button"
        aria-controls="offcanvasPrimaryMenu"
      >
        <i className="material-icons-outlined">menu</i>
      </a>
        </div>
       
        <ul className="navbar-nav gap-1 nav-right-links align-items-center">
          <li className="nav-item dropdown">
  <a className="nav-link dropdown-toggle dropdown-toggle-nocaret position-relative" data-bs-toggle="dropdown" href="javascript:;" aria-expanded="false">
    <span className="material-icons-outlined">notifications</span>
    <span className="badge-notify">1</span>
  </a>
  <div className="dropdown-menu dropdown-notify dropdown-menu-end shadow">
    <div className="px-3 py-1 d-flex align-items-center justify-content-between border-bottom">
      <h5 className="notiy-title mb-0">Notifications</h5>
    </div>
    <div className="notify-list">
      <div>
        <a className="dropdown-item border-bottom py-2" href="javascript:;">
          <div className="d-flex align-items-center gap-3">
            <div className="user-wrapper bg-primary text-primary bg-opacity-10">
              <span>RS</span>
            </div>
            <div>
              <h5 className="notify-title">New Account Created</h5>
              <p className="mb-0 notify-desc">From USA an user has registered.</p>
              <p className="mb-0 notify-time">Yesterday</p>
            </div>
            <div className="notify-close position-absolute end-0 me-3">
              <i className="material-icons-outlined fs-6">close</i>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</li>

<li className="nav-item dropdown">
  <a className="nav-link dropdown-toggle dropdown-toggle-nocaret position-relative" data-bs-toggle="dropdown" href="javascript:;" aria-expanded="false">
   <i className="material-icons-outlined">account_circle</i>
  </a>
  <div className="dropdown-menu dropdown-option dropdown-menu-end shadow">
    <div>
      <a className="dropdown-item d-flex align-items-center gap-2 py-2" href="#">
        <i className="material-icons-outlined fs-6">inventory_2</i>Logout
      </a>
    </div>
    
  </div>
</li>

        </ul>
      </nav>
    </header>
        </>
    );
};

export default Header;
